import TextInput from '~/components/TextInput';
import TextArea from '~/components/TextArea';
import { useState } from 'react';
import { countCodes } from '~/lib/CouponHelpers';

const CouponDetailsInput = ({ name, setName, codes, setCodes }) => {
    const [autofocusCodes, setAutofocusCodes] = useState(false);
    const isNameCode = name === codes || (!codes && !name);

    const numCodes = countCodes(codes);

    return (
        <div className="p-6">
            {isNameCode && (
                <>
                    <TextInput
                        onChange={newValue => {
                            setName(newValue);
                            setCodes(newValue);
                        }}
                        id="codes"
                        value={codes}
                        label="Code"
                        placeholder="Ex., 25OFF"
                    />
                    <a
                        href="#"
                        className="no-underline inline-block mt-1"
                        onClick={e => {
                            e.preventDefault();
                            setCodes(codes + '\n');
                            setAutofocusCodes(true);
                        }}
                    >
                        + Add multiple coupon codes
                    </a>
                </>
            )}

            {!isNameCode && (
                <div>
                    <TextInput
                        onChange={setName}
                        value={name || ''}
                        label="Name"
                        id="coupon.name"
                        className="mb-4"
                    />
                    <TextArea
                        id="codes"
                        autoFocus={autofocusCodes}
                        label={`Codes (${numCodes})`}
                        value={codes}
                        onChange={setCodes}
                        inputClassName="min-h-32"
                    />
                    <div className="text-gray-500">
                        Enter each code on a separate line
                    </div>
                </div>
            )}
        </div>
    );
};

export default CouponDetailsInput;
